"use client";

import React from "react";
import "./FAQ.css";
import Accordion from "react-bootstrap/Accordion";

const FAQ = () => {
  const faqs = [
    {
      id: "faq1",
      question: "Can I get a B.A  degree online?",
      answer:
        "Yes. You can pursue a BCom  degree through an online learning mode. The program provides structured academic learning, practical exposure, and industry-oriented knowledge through an online platform.",
    },
    {
      id: "faq2",
      question: "Is online B.A  valid?",
      answer:
        "Yes, an online BCom  program can be valid when offered by a recognized university and conducted according to the applicable higher-education regulations and guidelines.",
    },
    {
      id: "faq3",
      question: "Is Online B.A  from DPU-COL valid?",
      answer:
        "DPU-COL's Online BCom  program is designed to provide students with a recognized academic qualification along with practical and industry-relevant learning.",
    },
    {
      id: "faq4",
      question:
        "What practical skills will I gain from the online B.A  degree?",
      answer:
        "Students can develop skills in programming, database management, web development, software development, problem-solving, computer applications, and other industry-relevant technologies.",
    },
  ];

  return (
    <section className="FAQ_Section">
      <div className="container">
        <div className="FAQ_Section_Heading">
          <span className="FAQ_eyebrow">Frequently Asked Questions</span>

          <h2>
            FAQs About <span>Online B.A </span>
          </h2>

          <p>
            Find answers to some of the most common questions about our Online
            B.A program.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="FAQ_Accordion_Wrapper">
          <Accordion>
            {faqs.map((item, index) => (
              <Accordion.Item
                eventKey={item.id}
                key={item.id}
                className="FAQ_Accordion_Item"
              >
                <Accordion.Header>
                  <div className="FAQ_Question">
                    <span className="FAQ_Number">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <span>{item.question}</span>
                  </div>
                </Accordion.Header>

                <Accordion.Body>
                  <div className="FAQ_Answer">{item.answer}</div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
